import React from "react";
import { useSelector } from "react-redux";
import { cuFormat } from "../../../../components/coreUiTable/Format";

import Table from "../../../../components/coreUiTable/Table";
import ReactTooltip from "react-tooltip";

const addTooltip = (header, formattedValue) =>
  header === "Job Class Name" || header === "Metric/Report/User Name" ? (
    <span data-tip={formattedValue}>{formattedValue}</span>
  ) : (
    formattedValue
  );

const EventLogsTable = () => {
  const tableInfo = useSelector((state) => state.longRunningDelayedJobs?.tableInfo);

  if (!Object.keys(tableInfo).length) return null;

  const formattedSlots = cuFormat({
    customFn: (header, formattedValue) => addTooltip(header, formattedValue),
    headers: tableInfo.colHeaders,
    columns: tableInfo.columns
  });
  return (
    <div style={{ paddingTop: "40px" }}>
      <ReactTooltip effect="solid" />
      <Table
        itemsPerPage={100}
        sorter
        showCount
        scopedSlots={formattedSlots}
        table={{
          colHeaders: tableInfo?.colHeaders,
          data: tableInfo?.data
        }}
      />
    </div>
  );
};

export default EventLogsTable;
